import axios from 'axios';
import { objectToQuery } from 'common/helpers/filters.helper';
import {
  ITrackStoreAllStoresCollection,
  ITrackStoreNotificationCollection,
  ITrackStoreNotificationCollectionFilters,
  ITrackStoreOnDutyCollection,
  ITrackStoreOnDutyCollectionFilters,
  ITrackStoreOrderCollectionFilters,
  ITrackStoreOrderCollection,
  ITrackStoreStoreCollection,
  ITrackStoreSummary,
  ITrackStoreWeeklyGrid,
  ITrackStoreLiveStoresCollection,
  ITrackStoreOrderDetailsFilters,
  ITrackStoreOrderDetails,
  ITrackStoreLiveStoresCollectionFilters,
} from 'entities/TrackStore/TrackStore.models';

const basePath = '/cir-portal/track-store';

export const trackStoreTransport = {
  getStoreCollection: (): Promise<ITrackStoreStoreCollection> => axios.get(`${basePath}/stores`),
  getSummary: (): Promise<ITrackStoreSummary> => axios.get(`${basePath}/summary`),
  getWeeklyGrid: (): Promise<ITrackStoreWeeklyGrid> => axios.get(`${basePath}/weekly-grid`),
  getNotificationCollection: (
    filters: ITrackStoreNotificationCollectionFilters
  ): Promise<ITrackStoreNotificationCollection> => axios.get(`${basePath}/notifications${objectToQuery(filters)}`),
  getAllStoresCollection: (): Promise<ITrackStoreAllStoresCollection> => axios.get(`${basePath}/all-stores`),
  getOnDutyCollection: (filters?: ITrackStoreOnDutyCollectionFilters): Promise<ITrackStoreOnDutyCollection> =>
    axios.get(`${basePath}/on-duty${objectToQuery(filters)}`),
  getLiveStoresCollection: (
    filters?: ITrackStoreLiveStoresCollectionFilters
  ): Promise<ITrackStoreLiveStoresCollection> => axios.get(`${basePath}/live-stores${objectToQuery(filters)}`),
  getOrderCollection: (filters: ITrackStoreOrderCollectionFilters): Promise<ITrackStoreOrderCollection> =>
    axios.get(`${basePath}/orders${objectToQuery(filters)}`),
  getOrderDetails: ({ transactionId, ...filters }: ITrackStoreOrderDetailsFilters): Promise<ITrackStoreOrderDetails> =>
    axios.get(`${basePath}/orders/${transactionId}${objectToQuery(filters)}`),
};
